import Vue from 'vue'
import routesConfig from '../config/routes'
import store from "../store"
import VueRouter from 'vue-router'
import booking from '../pages/booking'
import extras from '../pages/extras'
import account from '../pages/account'
import payment from '../pages/payment'
import profile from '../pages/profile'
import summary from '../pages/summary'
import password from '../pages/password'

Vue.use(VueRouter)


const router = new VueRouter({
  routes: [
    { path: '/', component: booking, name: 'booking', props: (route) => ({
      initialBookingTypeId: parseInt(route.query.booking_type_id) || null,
      initialDate: route.query.date,
      initialTime: route.query.time,
      initialAdults: parseInt(route.query.adults) || parseInt(route.query.players) || null,
      initialJuniors: parseInt(route.query.juniors) || null,
      initialGames: parseInt(route.query.games) || null,
      initialDuration: parseInt(route.query.duration) || null,
      initialPromoCode: route.query.promo_code,
      initialScenarioFilter: route.query.scenario ? [route.query.scenario] : []
    }) },
    { path: '/extras', component: extras, name: 'extras' },
    { path: '/account', component: account, name: 'account', props: (route) => ({ accountExists: route.query.account_exists === '1'}) },
    { path: '/payment', component: payment, name: 'payment' },
    { path: '/profile', component: profile, name: 'profile' },
    { path: '/your-details', component: profile, name: 'your-details' },
    { path: '/summary', component: summary, name: 'summary' },
    { path: '/password', component: password, name: 'password', props: (route) => ({ guid: route.query.guid }) }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('session/ensureSession').then(() => {
    if ( to.matched.some(record => {
      console.log('to', record.name)
      if (record.name == 'booking') {
        store.dispatch('order/cancelBooking')
      }
      if (store.state.order.order.status == 'paid' && record.name != 'summary') {
        store.commit('order/resetOrder')
        store.commit('booking/resetOptions')
      }
      return !routesConfig[record.name] || routesConfig[record.name].allowed_statuses.indexOf(store.state.order.order.status) !== -1
    })) {
      console.log('next route')
      next()
    } else {
      console.log('disallow route')
      next('/')
    }
  })
})

export default router
